import * as React from "react";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Box from "@mui/material/Box";
import { Button, Tooltip, OutlinedInput, Dialog } from "@mui/material";
import Rating from "@mui/material/Rating";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import CloseIcon from "@mui/icons-material/Close";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FolderIcon from "@mui/icons-material/Folder";
import DeleteIcon from "@mui/icons-material/Delete";
import images from "../../../global-styles/images";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ButtonBase from "@mui/material/ButtonBase";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import CustomInput from "../../CustomInput";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import { appLogger } from "../../../utils";
import "./PreviewStyles/index.css";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  // padding: theme.spacing(1),
  color: theme.palette.text.secondary,
  boxShadow: "none",
  background: "none",
}));
const MobileFeatureRequest = (props: any) => {
  appLogger.info({
    infoObj: {
      method: "FeatureRequestPreview",
      component: "add-product",
      fileName: "FeatureRequestPreview.tsx",
      props: props,
    },
  });
  const { productParams } = props;
  const [checked, setChecked] = React.useState([0]);
  const [StdFrcontent, setStdFrcontent] = React.useState<any>("");
  const [selectedFrCat, setselectedFrCat] = React.useState<any>("");
  const [TestZoom, setTestZoom] = React.useState<any>("zoomout");

  const [previewAgent, setPreviewAgent] = React.useState(false);

  const handleTogglePreview = () => {
    setPreviewAgent((prevState) => !prevState);
  };

  const handleToggle = (value: number) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const FeatureReqSettingsrequireEmail = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.requireEmail == true
      ? "(required)"
      : "(optional)";
  };
  const GenSettingsFeatureReqcategoryHeading = () => {
    return (
      productParams.productParams.products[0].feedbackAgentSettings
        ?.featureReqSettings?.categoryHeading || ""
    );
  };
  const FeatureReqSettingsrequireCategory = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.featureReqSettings?.reqCategory == true
      ? "(required)"
      : "(optional)";
  };
  const FeatureReqSettingsCategories = () => {
    let content: any = "";
    if (
      productParams.productParams.products[0].feedbackAgentSettings
        ?.featureReqSettings?.categories?.length > 0
    ) {
      content = (
        <>
          <Typography sx={{ mt: 1 }}>
            <InputLabel
              id="demo-simple-select-label"
              className="bold-label"
              sx={{
                mb: 0.2,
                color: " #040000",
                fontSize: "11px",
                fontWeight: 500,
                lineHeight: "20px",
              }}
            >
              {` ${GenSettingsFeatureReqcategoryHeading()} ${FeatureReqSettingsrequireCategory()}`}
            </InputLabel>
            <FormControl fullWidth>
              <Select
                value={selectedFrCat}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                onChange={(event) => handleCatChange(event)}
              >
                <MenuItem value="" disabled>{`Select a Category ${
                  productParams.productParams.products[0].feedbackAgentSettings
                    ?.featureReqSettings?.reqCategory == true
                    ? "*"
                    : ""
                }`}</MenuItem>
                {productParams.productParams.products[0].feedbackAgentSettings?.featureReqSettings?.categories.map(
                  (val: any, index: any) => (
                    <MenuItem value={val.name}>{val.name}</MenuItem>
                  )
                )}
              </Select>
            </FormControl>
          </Typography>
          {/* <>{CatFeatureReqStdFeedbacks()}</> */}
        </>
      );
    }
    return content;
  };
  const handleCatChange = (event: any) => {
    setselectedFrCat(event.target.value);
    productParams.productParams.products[0].feedbackAgentSettings?.featureReqSettings?.categories.map(
      (val: any, index: any) => {
        if (val.name == event.target.value) {
          CatFeatureReqStdFeedbacks(event.target.value);
        }
      }
    );
  };

  const CatFeatureReqStdFeedbacks = (checkName: any) => {
    let content: any = "";
    if (
      productParams.productParams.products[0].feedbackAgentSettings
        ?.featureReqSettings?.categories?.length > 0
    ) {
      productParams.productParams.products[0].feedbackAgentSettings?.featureReqSettings?.categories.map(
        (val: any, index: any) => {
          if (val.feedbacks.length > 0 && val.name == checkName) {
            content = (
              <List
                sx={{
                  width: "100%",
                  maxWidth: 360,
                  ml: 0.5,
                  bgcolor: "background.paper",
                }}
              >
                {val.feedbacks.map((value: any) => {
                  const labelId = `checkbox-list-label-${value}`;
                  return (
                    <ListItem
                      key={value}
                      secondaryAction={
                        <IconButton
                          edge="end"
                          aria-label="comments"
                        ></IconButton>
                      }
                      disablePadding
                    >
                      <Checkbox
                        className="fdstdfeedbackscheck"
                        onClick={handleToggle(value)}
                        edge="start"
                        checked={checked.includes(value)}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{ "aria-labelledby": labelId }}
                      />
                      <ListItemText
                        className="agent-fb-catelist-text"
                        id={labelId}
                        primary={`${value}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            );
          }
        }
      );
    }
    setStdFrcontent(content);

    // return content
  };
  const FeatureReqSeverityHeading = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.featureReqSettings?.severityHeading;
  };
  const FeatureReqSeverityRequired = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.featureReqSettings?.showSeverity == true
      ? " (required)"
      : " (optional)";
  };

  const FeatureReqsTopdialogMsg = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.featureReqSettings?.dialogMsg;
  };
  const GeneralSettingsMainTitle = () => {
    return productParams.productParams.products[0].feedbackAgentSettings?.title;
  };

  const FeatureReqsCommentsHeading = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.featureReqSettings?.generalCommentsHeading;
  };
  const FeatureReqsCommentreqComments = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.featureReqSettings?.reqComments == true
      ? " (required)"
      : " (optional)";
  };
  const Mainlogo = () => {
    return productParams.productParams.products[0]?.logo;
  };
  React.useEffect(() => {
    if (
      productParams.productParams.products[0].feedbackAgentSettings
        ?.featureReqSettings?.categories?.length == 1
    ) {
      setselectedFrCat(
        productParams.productParams.products[0].feedbackAgentSettings
          ?.featureReqSettings?.categories[0].name
      );
      CatFeatureReqStdFeedbacks(
        productParams.productParams.products[0].feedbackAgentSettings
          ?.featureReqSettings?.categories[0].name
      );
    } else {
      setselectedFrCat("");
      setStdFrcontent("");
    }
  }, [
    productParams.productParams.products[0].feedbackAgentSettings
      ?.featureReqSettings?.categories?.length,
  ]);
  const freqfullscreenchanged = (event: any) => {
    // document.fullscreenElement will point to the element that
    // is in fullscreen mode if there is one. If not, the value
    // of the property is null.
    if (document.fullscreenElement) {
      setTestZoom("zoomin");
    } else {
      setTestZoom("zoomout");
    }
  };

  const el: any = document.getElementById("freq-fullscreen-div");
  const tt: any = document.getElementById("freq-toggle-fullscreen");

  if (el != null) {
    el.addEventListener("fullscreenchange", freqfullscreenchanged);
    // or
    el.onfreqfullscreenchange = freqfullscreenchanged;
  }

  if (tt != null) {
    // When the toggle button is clicked, enter/exit fullscreen

    tt.addEventListener("click", (event: any) => {
      if (document.fullscreenElement) {
        // exitFullscreen is only available on the Document object.
        document.exitFullscreen();
      } else {
        el.requestFullscreen();
      }
    });
  }
  const zoomClick = () => (event: any) => {
    const fullscreendiv: any = document.getElementById("mobile-widget");
    if (document.fullscreenElement) {
      setTestZoom("zoomout");
      // exitFullscreen is only available on the Document object.
      document.exitFullscreen();
    } else {
      fullscreendiv.requestFullscreen();
      setTestZoom("zoomin");
    }
  };

  const renderContent = () => {
    return (
      <Grid
        className={`mobile-mockup ${TestZoom}`}
        container
        sx={{
          mt: 1,
          p: 2,
          border: "1px solid #dbdce0",
          borderRadius: "35px",
          padding: "45px 10px 20px 10px",
          background: "#000",
          // boxShadow:
          //   "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
        }}
      >
        <Grid
          container
          alignItems="center"
          sx={{
            background: "#0157FF",
            borderRadius: "20px 20px 0 0",
            padding: "10px 12px",
          }}
        >
          <CloseIcon sx={{ color: "#fff", fontSize: "16px" }} />
          <Typography
            sx={{ color: "#fff", fontSize: "13px", marginLeft: "7px" }}
          >
            Request A Feature
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          md={12}
          className="preview-content"
          sx={{
            padding: "10px 12px 0",
            height: previewAgent ? "600px" : "390px",
            overflow: "auto",
            background: "#fff",
            borderRadius: "0 0 15px 15px",
            display: "flex",
            flexDirection: "column",
            "&::-webkit-scrollbar": {
              display: "none",
              "-ms-overflow-style": "none",
              scrollbarWidth: "none",
            },
          }}
        >
          <Box className="form-wrap">
            <Grid item xs={12}>
              <Typography
                className="freqdialogtitle"
                dangerouslySetInnerHTML={{
                  __html: FeatureReqsTopdialogMsg(),
                }}
                sx={{
                  color: " #040000",
                  fontSize: "12px",
                  fontWeight: 400,
                  margin: " 5px 0 15px",
                  textAlign: "left",
                }}
              >
                {/* {FeatureReqsTopdialogMsg()} */}
              </Typography>
            </Grid>
            <Box
              component="form"
              method="post"
              noValidate
              className="custom-select custom-select-agent-box"
            >
              <Box sx={{ mt: 1 }} className="custom-select-agent">
                <CustomInput
                  placeholder="Your email"
                  label={`Email Address ${FeatureReqSettingsrequireEmail()}`}
                  type="text"
                  id=""
                  value={""}
                  name={""}
                  error={false}
                  helperText={undefined}
                  customLabelSx={{
                    color: " #040000",
                    fontSize: "11px",
                    fontWeight: 500,
                    lineHeight: "20px",
                  }}
                />
              </Box>
              <> {FeatureReqSettingsCategories()}</>
              <>{StdFrcontent}</>
              <Typography sx={{ mt: 1 }}>
                <InputLabel
                  id="demo-simple-select-label"
                  className="bold-label"
                  sx={{
                    mb: 0.2,
                    color: " #040000",
                    fontSize: "11px",
                    fontWeight: 500,
                    lineHeight: "20px",
                  }}
                >
                  {FeatureReqsCommentsHeading()}
                  {FeatureReqsCommentreqComments()}
                </InputLabel>
                <FormControl
                  className="custom-select custom-textarea"
                  fullWidth
                >
                  <OutlinedInput
                    type="textarea"
                    id="desc-input"
                    multiline
                    placeholder={`Provide your comments ${
                      productParams.productParams.products[0]
                        .feedbackAgentSettings?.featureReqSettings
                        ?.reqComments == true
                        ? "*"
                        : ""
                    }`}
                    maxRows={4}
                  />
                </FormControl>
              </Typography>
              {/* ****************************** */}
              <InputLabel
                id="demo-simple-select-label"
                sx={{
                  mt: 1,
                  mb: 0.2,
                  whiteSpace: "normal",
                  color: "#00000099",
                  fontSize: "10px",
                  fontWeight: 500,
                  lineHeight: "18px",
                }}
                className="attach-label"
              >
                Please attach screenshot/audio/screen recording to help
                troubleshoot (optional)
              </InputLabel>
              <Box
                // className="attach-main-box"
                sx={{
                  mt: 1,
                  flexGrow: 1,
                  p: 2,
                  borderRadius: "8px",
                  border: "1px solid #0157ff",
                  padding: "10px 5px",
                }}
              >
                <Grid
                  container
                  spacing={3}
                  sx={{
                    margin: "0",
                    width: "100%",
                  }}
                >
                  <Grid
                    item
                    xs
                    sx={{
                      width: "25%!important",
                      flex: "0 0 auto!important",
                      padding: "0!important",
                      textAlign: "center",
                    }}
                  >
                    <Box>
                      <Item
                        sx={{
                          height: "30px!important",
                          width: "30px!important",
                          alignItems: "center",
                          borderRadius: "50%",
                          display: "inline-flex",
                          justifyContent: "center",
                        }}
                      >
                        <i
                          className="icon-screenshot"
                          style={{
                            color: "#0157ff",
                            fontSize: "10px",
                          }}
                        />
                      </Item>
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: previewAgent ? "10px" : "7px",
                        }}
                      >
                        Screenshot
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs
                    sx={{
                      width: "25%!important",
                      flex: "0 0 auto!important",
                      padding: "0!important",
                      textAlign: "center",
                    }}
                  >
                    <Box>
                      <Item
                        sx={{
                          height: "30px!important",
                          width: "30px!important",
                          alignItems: "center",
                          borderRadius: "50%",
                          display: "inline-flex",
                          justifyContent: "center",
                        }}
                      >
                        <i
                          className="icon-video"
                          style={{
                            color: "#0157ff",
                            fontSize: "10px",
                          }}
                        />
                      </Item>
                      <Typography
                        // className="atth-prev-text"
                        sx={{
                          fontWeight: 700,
                          fontSize: previewAgent ? "10px" : "7px",
                        }}
                      >
                        Screen Recorder
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs className="attach-grid-prev">
                    <Box>
                      <Item
                        sx={{
                          height: "30px!important",
                          width: "30px!important",
                          alignItems: "center",
                          borderRadius: "50%",
                          display: "inline-flex",
                          justifyContent: "center",
                        }}
                      >
                        <i
                          className="icon-audio"
                          style={{
                            color: "#0157ff",
                            fontSize: "10px",
                          }}
                        />
                      </Item>
                      <Typography
                        // className="atth-prev-text"
                        sx={{
                          fontWeight: 700,
                          fontSize: previewAgent ? "10px" : "7px",
                        }}
                      >
                        Capture Audio
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs className="attach-grid-prev">
                    <Box>
                      <Item
                        // className="attch-icons"
                        sx={{
                          height: "30px!important",
                          width: "30px!important",
                          alignItems: "center",
                          borderRadius: "50%",
                          display: "inline-flex",
                          justifyContent: "center",
                        }}
                      >
                        <i
                          className="icon-attach"
                          style={{
                            color: "#0157ff",
                            fontSize: "10px",
                          }}
                        />
                      </Item>
                      <Typography
                        // className="atth-prev-text"
                        sx={{
                          fontWeight: 700,
                          fontSize: previewAgent ? "10px" : "7px",
                        }}
                      >
                        Attach a file
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
              {/* *************************************** */}
            </Box>
          </Box>

          <Grid
            container
            rowSpacing={1}
            className="mobile-footer-btn"
            sx={{
              display: "flex",
              margin: " auto -12px 0",
              paddingTop: "15px",
              width: "auto",
              maxWidth: "calc(100% + 24px)",
              borderRadius: "0 0 15px 15px",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              sx={{
                flexGrow: 1,
                borderRadius: 0,
                boxShadow: "none",
                fontSize: "12px",
              }}
            >
              submit
            </Button>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      <Typography className="prev-text-titile">
        Feature Request Settings: Preview &nbsp;
      </Typography>
      {!previewAgent && (
        <Grid container justifyContent="center" mt={1} mb={1}>
          <Typography
            className="tv-agent-preview-btn guideTourViewActualSize"
            onClick={handleTogglePreview}
            sx={{ color: "#0157FF", fontSize: 12 }}
          >
            Click to preview actual size
          </Typography>
        </Grid>
      )}
      <div style={{ marginTop: "20px" }}>{renderContent()}</div>
      {previewAgent && (
        <Dialog
          open={previewAgent}
          onClose={handleTogglePreview}
          sx={{
            "& .MuiPaper-root": {
              // borderRadius: "20px",
              // maxWidth: "390px",
              // minWidth: "390px",
              // minHeight: "700px",
              // maxHeight: "844px",
              background: "transparent",
              boxShadow: "none",
              "&::-webkit-scrollbar": {
                display: "none",
                "-ms-overflow-style": "none",
                scrollbarWidth: "none",
              },
              overflow: "inherit",
              position: "relative",
            },
            "& .MuiBackdrop-root": {
              backgroundColor: "#808080",
            },
            maxWidth: "390px",
            maxHeight: "844px",
            margin: "auto",
          }}
        >
          {previewAgent && (
            <Typography className="mobile-agent-preview-close">
              For Preview
              <span onClick={handleTogglePreview} className="prevclose">
                &nbsp; x &nbsp;Close&nbsp;
              </span>
            </Typography>
          )}
          {renderContent()}
        </Dialog>
      )}
    </>
  );
};

export default MobileFeatureRequest;
